export const selectUsersStatus = (state) => state?.users?.status;
export const selectUsersError = (state) => state?.users?.error;
export const selectUsersList = (state) => state?.users?.list;
export const selectUsersListNew = (state) => state?.users?.listNew;
